import { createApiHandler } from './handler';

const products = {
  apiClient: null,
  path: '/admin/products',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async saveImage(form) {
    try {
      const response = await this.apiClient.post(`${this.path}/image`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async removeImage(productId, imageId) {
    try {
      const response = await this.apiClient.delete(`${this.path}/${productId}/images/${imageId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async reorderImages(productId, imageIds) {
    try {
      const response = await this.apiClient.put(`${this.path}/${productId}/images/reorder`, {
        image_ids: imageIds,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateImageAltText(productId, imageId, altText) {
    try {
      const response = await this.apiClient.put(
        `${this.path}/${productId}/images/${imageId}/alt-text`,
        { alt_text: altText },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateStock(id, form) {
    try {
      const response = await this.apiClient.put(`${this.path}/${id}/stock`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

export default products;
